import { useTranslation } from "@coworker/locales";
import { ApplyFilter } from "@coworker/apprestructured/src/shared/filters/types/apply";
import {
  FilterType,
  FilterValue,
  InputType,
  SelectFilter,
} from "@coworker/apprestructured/src/shared/filters/types/filter";
import { Article, Combined } from "../types/article";
import { useCustomAllSelectOption } from "@coworker/apprestructured/src/shared/filters/utils/useAllSelectOption";

const ONGOING_ID = "ongoing";

function useTasksSelectFilter() {
  const { t } = useTranslation();
  const defaultValue = { filterId: ONGOING_ID, value: "" };

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: ONGOING_ID,
      title: t("ongoingTasksString"),
      options: [
        { value: "ongoingTasks", title: t("articlesWithOngoingTasksString") },
        {
          value: "noOngoingTasks",
          title: t("articlesWithNoOngoingTasksString"),
        },
      ],
      enabled: true,
      defaultValue,
    },
    t("allArticlesString")
  );
}

function useTasksSelectArticleFilter() {
  const filter: ApplyFilter<SelectFilter, Article> = {
    filter: useTasksSelectFilter(),
    filterCompare: (item: Combined<Article>, { value }: FilterValue) => {
      // Must stay in sync with the ongoing task badge, which is also v1 + v2.
      const hasOngoingTasks =
        Boolean(item.tasks && item.tasks.length) || Boolean(item.hasV2Tasks);

      switch (value) {
        case "ongoingTasks":
          return hasOngoingTasks;
        case "noOngoingTasks":
          return !hasOngoingTasks;
        default:
          return true;
      }
    },
  };

  return filter;
}

export { useTasksSelectArticleFilter };
